import { BaseCRUD } from '@/services/base-request';
import { toastError } from '@/composables/toast';

const serviceName = 'users';

export class UserService {
    /**
     * @param {object} body
     * @returns {Promise<Response>}
     */
    static async logIn (body) {
        const resp = await BaseCRUD.POST({
            service: serviceName,
            entity: 'staffs/login',
            body,
        });

        if (!resp.status.ok) {
            if (resp.status.code === 404) toastError('serverError');
            if (resp.status.code === 401) toastError('incorrectCredential');
            return null;
        }
        return resp.status.ok;
    };

    static async logOut () {
        const resp = await BaseCRUD.DELETE({
            service: serviceName,
            entity: 'staffs/logout',
        });

        if (!resp.status.ok) {
            return null;
        }
        return resp.status.ok;
    };

    static async getMe () {
        const resp = await BaseCRUD.GET({
            service: serviceName,
            entity: 'staffs/me',
        });

        if (!resp.status.ok) {
            if (resp.status.code === 404) toastError('serverError');
            return null;
        }
        return resp.payload;
    };
}
